export const INTERNAL_FUND_INFORMATION_TAB = "Internal Fund Information" as const;

export interface DeriveIsInternalContextArgs {
  hasInternal: boolean;
  hasExternal: boolean;
  activeInfoTab: string | null | undefined;
}

export const deriveIsInternalContext = ({
  hasInternal,
  hasExternal,
  activeInfoTab,
}: DeriveIsInternalContextArgs): boolean => {
  if (hasInternal && hasExternal) {
    return activeInfoTab === INTERNAL_FUND_INFORMATION_TAB;
  }

  if (hasInternal && !hasExternal) {
    return true;
  }

  if (!hasInternal && hasExternal) {
    return false;
  }

  return true;
};
